<template>
    <transition name="slide-left">
        <div id="side-menu" :style="{'background': background, 'max-width': maxWidth}">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            background: {
                type: String,
                required: false,
                default: '#fff'
            },
            maxWidth: {
                type: String,
                required: false,
                default: '100%'
            },
            overlayColor: {
                type: String,
                required: false,
                default: 'rgba(0,0,0,.5)'
            }
        },
        data() {
            return {}
        },
        methods: {},
    }
</script>

<style lang="scss">
    #side-menu {
        position: fixed;
        display: flex;
        top: 0;
        left: 0;
        height: 100vh;
        padding: 30px 30px;
        box-shadow: 5px 0px 25px 0px rgba(0, 0, 0, 0.2);
        z-index: 9999;
        overflow: hidden;
        z-index: 110;

        .d-flex {
            width: 100%;
        }
    }

    .side-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: 100;
    }

    .slide-left-enter-active,
    .slide-left-leave-active {
        transition: transform 500ms ease-out;
    }

    .slide-left-enter,
    .slide-left-leave-to {
        transform: translateX(-100%);
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 500ms ease-out;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    @media only screen and (min-width: 992px) {
        #side-menu {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/js/components/side-menu/side-menu.vue